export default {
    onboardingCasesList : "/workflow/action-detail/list/",
    mpaDetailBaseURL : 'company/mpa-details',
    deviationMatrixList : "/company/mpa-approval/deviation-matrix/",
    minutesOfMeeting: "/minute_of_meeting/",
    baseFeeSlab: "/company/fee-slab/",
    onboardingCasePendence: "/workflow/action-detail/:actionDetailId/proceed-pendency/",
    dbDeviationList: "company/db-deviation/",
    getEnums: "company/get-enums/",
    gstinConsent:"master/gstin-consent/",
    camEngineAutomation: "case/:case_id/cam-engine-automation/",
    getBounceChargesMaster: "company/bounce_charges/list/",
    getPrePaymentChargesMaster: "scheme/foreclosure/master/",
    bounceChargeData: "company/bounce_charges/:companyId/seller-configuration/",
    prePaymentChargesData: "scheme/foreclosure/:companyId/seller-configuration/",
    editPrePaymentCharges: "scheme/foreclosure/:companyId/:caseId/case-configuration/",
    editBounceCharges: "company/bounce_charges/:companyId/:caseId/case-configuration/",
    editCaseFee: "scheme/fee/:companyId/:caseId/case-configuration/",
    resetSchedule: "case/:case_id/bnpl/emi/schedule/reset/",
    deferralTag: "case/:case_id/case-deferral-tag/",
    retailerPotentialRisk: "case/:case_id/retailer-deviation-cases/",
    companyBackground: "company/background/",
    deviationMatrix: "company/background/deviation/",
    OverdueCibilAccountDetails: "case/cibil/:case_id/",
    companyDocumentAadharMask: "company/applicant/aadhar-mask/",
    trackwizzEntity: "company/trackwizz_entity/",
    caseBuyerExposure: "case/buyer_exposure/",
    caseBuyerExposureSanctionView: "case/:case_id/sanction-view-detail/",
    assessmentReportUpdate: "case/:case_id/update-assessment-parameter/",
    match_ledger: "case/:case_id/match-ledger-banking/",
    eligibilityCalculator: "case/:case_id/eligibility-calculator-data/",
    aadharPanLink: "company/pan-aadhar-link/",
};
